package link.erpango.quip.core

import link.erpango.quip.QuipConstants
import link.erpango.quip.data.IDataSource
import link.erpango.quip.data.remote.DResponse
import link.erpango.quip.utils.DatetimeUtils

class CatalogSyncManager(
    private val dataSource: IDataSource
) {
    /**
     * Sincroniza el catálogo de marcas y modelos con el servidor.
     * - Primera vez (sin timestamp guardado): descarga todo el catálogo.
     * - Siguientes veces: solo trae cambios desde el último sync.
     * - Si no hay cambios, no toca la DB local.
     *
     * @return true si se sincronizó correctamente, false si hubo error.
     */
    suspend fun sync(): Boolean {
        val lastSync = dataSource.db.commonValues
            .selectValue(QuipConstants.CommonValues.Catalog.lastCatalogSync)
            ?.toLongOrNull()

        val response = dataSource.remote.catalog.getCatalog(updatedSince = lastSync)

        if (response is DResponse.Success) {
            val catalog = response.data
            if (catalog.brands.isNotEmpty()) {
                for (brand in catalog.brands) {
                    dataSource.db.catalog.upsertBrand(brand.id, brand.name, brand.updated_at)
                    for (model in brand.models) {
                        dataSource.db.catalog.upsertModel(model.id, brand.id, model.name, model.updated_at)
                    }
                }
            }
            // Actualizar timestamp con la hora del servidor
            dataSource.db.commonValues.insertValue(
                QuipConstants.CommonValues.Catalog.lastCatalogSync,
                catalog.server_time.toString(),
                DatetimeUtils.currentTimeMillis()
            )
            return true
        }
        return false
    }
}
